import Modal from '@oberoninternal/travelbase-ds/components/layout/Modal';
import { useDeviceSize } from '@oberoninternal/travelbase-ds/context/devicesize';
import { Sesame } from '@oberoninternal/travelbase-ds/hooks/useSesame';
import { Box } from '@rebass/grid';
import { useRef } from 'react';
import styled from 'styled-components';
import ActivityPlanner, { ActivityPlannerProps, OnSelectScrollOptions } from './ActivityPlanner';
import ActivityTickets, { ActivityTicketsProps } from './ActivityTickets';

interface ActivityProp {
    activityTickets?: boolean;
    openActivityTickets?: boolean;
    openActivityPlanner?: boolean;
    onActvityBack?: () => void;
    onActivityPlanner?: () => void;
    onModalClose?: () => void;
}

const ActivityPlannerModal = ({
    activity,
    slug,
    selectedDay,
    setSelectedDay,
    setTimeslot,
    open,
    onClose,
    setTicket,
    ticket,
    timeslot,
    setEdit,
    activityTickets,
    openActivityTickets,
    openActivityPlanner,
    onActvityBack,
    onActivityPlanner,
    onModalClose,
}: ActivityPlannerProps & ActivityTicketsProps & ActivityProp & Pick<Sesame, 'open' | 'onClose'>) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const scrollOptions: OnSelectScrollOptions = {
        scrollRef: modalRef,
    };

    const deviceSize = useDeviceSize();

    return (
        <StyledModal contentRef={modalRef} open={open} onClose={onClose} variant="full">
            <Content>
                {deviceSize !== 'mobile' && (
                    <>
                        {!activityTickets && (
                            <ActivityPlanner
                                activity={activity}
                                onSelectScrollOpts={scrollOptions}
                                slug={slug}
                                selectedDay={selectedDay}
                                setSelectedDay={setSelectedDay}
                                setTimeslot={setTimeslot}
                                isOpenModal={open}
                            />
                        )}
                        {activityTickets && (
                            <ActivityTickets
                                activity={activity!}
                                setTicket={setTicket}
                                onClose={onClose}
                                open={open}
                                timeslot={timeslot}
                                ticket={ticket}
                                setEdit={setEdit}
                            />
                        )}
                    </>
                )}
                {deviceSize === 'mobile' && (
                    <ActivityPlanner
                        activity={activity}
                        onSelectScrollOpts={scrollOptions}
                        slug={slug}
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        setTimeslot={setTimeslot}
                        isOpenModal={open}
                        setTicket={setTicket}
                        activityTimeslot={timeslot}
                        ticket={ticket}
                        openActivityTickets={openActivityTickets}
                        onBack={onActvityBack}
                        openActivityPlanner={openActivityPlanner}
                        onActivityPlanner={onActivityPlanner}
                        onModalClose={onModalClose}
                    />
                )}
            </Content>
        </StyledModal>
    );
};

export default ActivityPlannerModal;

const Content = styled(Box)`
    overflow: hidden;
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        padding: 4rem 2.4rem 10rem 2.4rem;
        overflow: visible;
    }
    width: 100%;
    max-width: 140.8rem;
    margin: auto;
    @media screen and (max-width: ${({ theme }) => theme.mediaQueriesValues.s - 1}px) {
        height: 100%;
    }
`;

const StyledModal = styled(Modal)`
    && {
        padding: 0;
    }
`;
